import React, { useState } from 'react';
import Subtitle2 from '@fuww/library/src/Typography/SubTitle2';
import LoginFormComponent from '@fuww/library/src/Users/LoginForm';
import { useApolloClient, useMutation, ApolloError } from '@apollo/client';
import { useIntl } from 'react-intl';
import LinkAndAnchor from '../LinkAndAnchor';
import ServerValidation from '../ServerValidation';
import messages from '../../lib/messages.json';
import loginMutation from '../../lib/mutations/login.graphql';
import onLogin from '../../lib/onLogin';
import { useSiteContext } from '../SiteContext';
import createAnalyticsEventMutation
  from '../../lib/mutations/createAnalyticsEvent.graphql';

const LoginForm = () => {
  const intl = useIntl();

  const [submitErrors, setSubmitErrors] = useState<ApolloError | null>(null);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const client = useApolloClient();

  const {
    prefix,
    hasLocalNews,
    url,
    newsboard,
  } = useSiteContext();

  const [createAnalyticsEvent] = useMutation(createAnalyticsEventMutation);

  const [
    createSession,
  ] = useMutation(loginMutation, {
    onCompleted: (data) => {
      onLogin(
        data,
        setSubmitDisabled,
        intl.formatMessage(messages['login.successHeadline']),
        client,
        'LoginPage',
        createAnalyticsEvent,
        prefix,
        hasLocalNews,
        url,
        newsboard,
      );
    },
    onError: (error) => {
      setSubmitDisabled(false);
      setSubmitErrors(error);
    },
  });

  const submitHandler = ({
    password, username,
  }: { password: string; username: string }) => {
    setSubmitDisabled(true);
    createSession({
      variables: {
        username,
        password,
      },
    });
  };

  return (
    <LoginFormComponent
      requiredValidationMessage={intl.formatMessage(messages[
        'applicantForm.fieldRequired'
      ])}
      emailValidationMessage={intl.formatMessage(messages[
        'applicantForm.mustBeValidEmailAddress'
      ])}
      emailLabel={intl.formatMessage(messages.emailAddress)}
      passwordLabel={intl.formatMessage(messages.password)}
      submitLabel={intl.formatMessage(messages.continue)}
      forgotPasswordLink={(
        <LinkAndAnchor
          route="reset-password"
        >
          <Subtitle2 tag="span">
            {intl.formatMessage(messages.forgotPassword)}
          </Subtitle2>
        </LinkAndAnchor>
      )}
      submitHandler={submitHandler}
      submitDisabled={submitDisabled}
      serverValidation={submitErrors ? (
        <ServerValidation errors={submitErrors} />
      ) : null}
    />
  );
};

export default LoginForm;
